import React from 'react';

const UserControl = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 24">
    <g fill="#9B9B9B" fillRule="nonzero" stroke="none" strokeWidth="1">
      <path
        d="M10 12.125a5.725 5.725 0 100-11.45 5.725 5.725 0 000 11.45zm0-2a3.725 3.725 0 110-7.45 3.725 3.725 0 010 7.45z"
        transform="translate(-26 -536) translate(0 80) translate(0 432) translate(26 24)"
      />
      <path
        d="M5.208 4.695a8.84 8.84 0 009.868 1.983 1 1 0 00-.792-1.836 6.84 6.84 0 01-7.636-1.535 1 1 0 10-1.44 1.388zM2.225 22.925a7.775 7.775 0 0115.55 0 1 1 0 002 0c0-5.399-4.376-9.775-9.775-9.775S.225 17.526.225 22.925a1 1 0 002 0z"
        transform="translate(-26 -536) translate(0 80) translate(0 432) translate(26 24)"
      />
      <path
        d="M5.625 14.824v.676a4.375 4.375 0 108.75 0v-.676a1 1 0 00-2 0v.676a2.375 2.375 0 11-4.75 0v-.676a1 1 0 00-2 0z"
        transform="translate(-26 -536) translate(0 80) translate(0 432) translate(26 24)"
      />
    </g>
  </svg>
);

export default UserControl;
